import React, { useState } from 'react';
import { message } from 'antd';
import { SFuncModal } from 'shj-components';
import {callDispatchSales} from '@/services/callCenter'

export function dispatchModalFn({ fn, ...rest }) {
    const destroy = () => {
        dialog.destroy();
    };
    const dialog: any = SFuncModal({
        title: '线索状态变更',
        width: 400,
        vanish: true,
        content: <SubmitInvalidFnDom fn={fn} onClose={destroy} {...rest} />,
    });
}
const SubmitInvalidFnDom = ({ fn, onClose, clueId, content, buttonKey }) => {

    const [loading, setLoading] = useState(false);

    const onFinish = () => {
        if (loading) return
        setLoading(true)
        callDispatchSales({ clueId , buttonKey}).then((res: any) => {
            message.success(res?.data || '操作成功')
            onClose()
            fn&&fn()
        }).finally(() => {
            setLoading(false)
        })
    }
    return <SFuncModal.Content
        onCancel={onClose}
        onOk={onFinish}
        confirmLoading={loading}
    >
        {content}
    </SFuncModal.Content>
}